import { createReactComponent } from '@tabler/icons-react';

export const IconCustomEyeReview = createReactComponent(
  'outline',
  'customEyeReview',
  'CustomEyeReview',
  [
    [
      'path',
      {
        key: 'iconCustomEyeReview-path',
        d: 'M10 15C7 15 4.5 13.3333 2.5 10C4.5 6.66667 7 5 10 5C13 5 15.5 6.66667 17.5 10M18.3333 15.8333H13.3333M13.3333 15.8333L15.8333 18.3333M13.3333 15.8333L15.8333 13.3333M8.33333 10C8.33333 10.442 8.50893 10.866 8.82149 11.1785C9.13405 11.4911 9.55797 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.866 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333C9.55797 8.33333 9.13405 8.50893 8.82149 8.82149C8.50893 9.13405 8.33333 9.55797 8.33333 10Z',
      },
    ],
  ]
);
